import React, { Component } from 'react'
import PropTypes from 'prop-types'

class WhenTimeButton extends Component {

  constructor(props) {
    super(props)
    this.addCapacityWarning = props.addCapacityWarning.bind(this)
    this.dateAsTime = props.date.getTime()
    this.booking = props.booking
    this.startAsTime = new Date(this.booking.whenStartTime).getTime()
    this.endAsTime = new Date(this.booking.whenEndTime).getTime()
  }

  componentDidMount() {
    if (this.overCapacity() 
      && this.dateAsTime >= this.startAsTime
      && this.dateAsTime < this.endAsTime
    ) {
      this.addCapacityWarning();
    }
  }

  statusCss() {
    const { date } = this.props
    const baseCss = 'mt-1 py-2'
    const full = this.overCapacity()

    if (this.dateAsTime === this.startAsTime) {
      return `absolute z-10 w-full bg-harbor ${ full ? 'text-red' : 'text-white'} rounded-full py-4 -mt-5 shadow-md`
    }

    if (this.dateAsTime > this.startAsTime && this.dateAsTime < this.endAsTime) {
      return `bg-grey-lighter ${baseCss} ${date.getMinutes() === 0 && 'rounded-l-full'} ${date.getMinutes() === 45 && 'rounded-r-full'} ${ full && 'text-red' }`
    }

    if (this.dateAsTime === this.endAsTime) {
      return `rounded-full bg-grey mt-1 py-2` //  ${full && 'text-red' }
    }

    return (full ? 'text-grey-light mt-1 py-2' : 'text-harbor mt-1 py-2')
  }

  overCapacity() {
    const { bookings, reservations, capacity, amountPeople } = this.props
    const bookingsSum = bookings.reduce((a, b) => a + parseInt(b.orderCount, 10), 0)
    const reservationsSum = reservations.reduce((a, b) => a + parseInt(b.amountPeople, 10), 0)
    return bookingsSum + reservationsSum + amountPeople > capacity
  }
  
  render() {
    const { date, selectedTimeChanged } = this.props

    return (
      <button 
        type="button"
        onClick={() => selectedTimeChanged(date)}
        id="whenStartTime"
        name="whenStartTime"
        className="relative h-8 md:h-10 py-1 w-full text-sm md:text-2xl font-bold"
      >
        <div className={this.statusCss()}>
          {date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}
          :
          {date.getMinutes()}
          {date.getMinutes() === 0 && '0'}
        </div>
      </button>
    )
  }
}

WhenTimeButton.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  bookings: PropTypes.instanceOf(Array).isRequired,
  reservations: PropTypes.instanceOf(Array).isRequired,
  selectedTimeChanged: PropTypes.func.isRequired,
  booking: PropTypes.shape({ booking: PropTypes.object }).isRequired,
  capacity: PropTypes.number.isRequired,
  amountPeople: PropTypes.number.isRequired,
  addCapacityWarning: PropTypes.func.isRequired
}

WhenTimeButton.defaultProps = {}

export default WhenTimeButton